import styled from "@emotion/styled";

// Sidbar container
export const SidebarContainer = styled.div`
  display: grid;
  grid-template-rows: 10% 70% 20%;
  width: ${(p) => (p.isSidebarOpen ? "15%" : "5%")};
  overflow: hidden;
  height: 100vh;

  min-width: 80px;
  border-right: 1px solid #e4e4e4;
  position: relative;
  transition: 0.2s ease-in all;
`;

//  Logo container
export const LogoContainer = styled.div`
  margin-left: ${(p) => (p.isSidebarOpen ? "2.6rem" : "0.6rem")};
  margin-top: 3.2rem;
  height: 50px;
  width: 50px;
  transition: 0.2s ease-in all;
`;
export const LogoImage = styled.img``;

// Menu Items Container
export const MenuItemsContainer = styled.div`
  display: grid;
  align-items: center;
  align-content: center;
  width: ${(p) => (p.isSidebarOpen ? "75%" : "75%")};

  a {
    cursor: pointer;
    text-decoration: none;
    margin: 0.5rem 0;
  }
`;
export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  padding: 1.1rem;
  background-color: ${(p) => (p.active ? "#727568" : "inherit")};
  border-radius: 0 10px 10px 0;
  color: ${(p) => (p.active ? "#fff" : "#808191")};
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    background-color: ${(p) => (p.active ? "#727568" : "#ddd")};
    color: #fff;
    transition: 0.15s ease-in all;
  }
  transition: 0.2s ease-in all;
`;

// Icon For Items
// export const Icon = styled.img`
//   height: 25px;
//   width: 25px;
// `;

export const Icon = styled.i`
  font-size: 1.2rem;
`;
export const Text = styled.span`
  display: ${(p) => (p.isSidebarOpen ? "inline" : "none")};
`;

// Avatar Container
export const AvatarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 5rem;
  margin-left: ${(p) => (p.isSidebarOpen ? "2rem" : "1rem")};
`;
export const AvatarImage = styled.img`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;
export const AvatarTextContair = styled.div`
  display: ${(p) => (p.isSidebarOpen ? "grid" : "none")};
  white-space: nowrap;
`;

export const Lead = styled.span`
  font-weight: 600;
`;
export const AvatarType = styled.span`
  color: #808191;
`;
